/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation"; // Rename to your file name for custom animation

// Splash Screen

const splashScreen = {
  enabled: true, // set false to disable splash screen
  animation: splashAnimation,
  duration: 2000 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
  animated: false // Hero uses the editorial portfolio artwork
};

const greeting = {
  username: "Syafiqah Hisham",
  title: "Hi, I'm Syafiqah 👋",
  subTitle:
    "I've spent about 4 years building banking systems — mostly backend, Java and Spring Boot, with a bit of React thrown in when needed. Nothing too fancy, just APIs and services that need to actually work when someone's making a transaction. Currently picking up bits of AWS and AI on the side.",
  resumeLink: "YOUR_RESUME_LINK",
  displayGreeting: true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/IqaHisham",
  linkedin: "https://www.linkedin.com/in/syafiqah-nabilah-31588b187/",
  gmail: "syafiqahnabilah98@gmail.com",
  gitlab: "",
  facebook: "",
  medium: "",
  stackoverflow: "",
  // Instagram, Twitter and Kaggle are also supported in the links!
  // To customize icons and social links, tweak src/components/SocialMedia
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "What I Build",
  subTitle:
    "BACKEND SYSTEMS · REST APIs · MICROSERVICES · FULL-STACK APPLICATIONS",

  skills: [
    emoji("⚡ Build scalable RESTful APIs using Java 21, Spring Boot and Spring MVC"),
    emoji("⚡ Develop enterprise microservices, API integrations and backend business logic"),
    emoji("⚡ Troubleshoot production issues, perform VAPT remediation and support production deployments"),
    emoji("⚡ Write clean, maintainable code with Hibernate/JPA, JUnit and Mockito"),
    emoji("⚡ Currently learning AWS, Docker, Kubernetes and cloud-native development")
  ],

  softwareSkills: [
    {
      skillName: "Java",
      fontAwesomeClassname: "fab fa-java"
    },
    {
      skillName: "Spring Boot",
      fontAwesomeClassname: "fa fa-leaf"
    },
    {
      skillName: "SQL",
      fontAwesomeClassname: "fas fa-database"
    },
    {
      skillName: "Git",
      fontAwesomeClassname: "fab fa-git-alt"
    },
    {
      skillName: "Maven",
      fontAwesomeClassname: "fas fa-cogs"
    },
    {
      skillName: "Docker",
      fontAwesomeClassname: "fab fa-docker"
    },
    {
      skillName: "AWS",
      fontAwesomeClassname: "fab fa-aws"
    },
    {
      skillName: "Jenkins",
      fontAwesomeClassname: "fab fa-jenkins"
    },
    {
      skillName: "Linux",
      fontAwesomeClassname: "fab fa-linux"
    }
  ],

  display: true
};
// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "Universiti Malaysia Terengganu",
      logo: require("./assets/images/Logo_Rasmi_UMT.png"),
      subHeader: "Bachelor of Computer Science(Software Engineering)",
      duration: "September 2019 - March 2023",
      desc: "Where I picked up the fundamentals I still use daily — OOP, software testing, cyber security, IoT, system design.",
      descBullets: [
        "Java Programming",
        "Software Engineering",
        "Software Testing","Database Systems","Web Development","Cyber Security",
        "System Analysis & Design"
      ]
    },
    {
      schoolName: "Kolej Vokasional Perdagangan Johor Bahru",
      logo: require("./assets/images/Logo_Rasmi_KV.png"),
      subHeader: "Diploma in Database Management System and Web Application",
      duration: "September 2013 - April 2017",
      desc: "Where it all started — web development in PHP, database management, mobile app development.",
      descBullets: [
        "PHP Development",
        "Database Management",
        "Mobile Application Development",
        "System Analysis","Software Maintenance"
      ]
    }
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: false,

  experience: [
    {
      Stack: "Backend Development",
      progressPercentage: "90%"
    },
    {
      Stack: "REST API Development",
      progressPercentage: "90%"
    },
    {
      Stack: "Microservices",
      progressPercentage: "80%"
    },
    {
      Stack: "Database",
      progressPercentage: "80%"
    },
    {
      Stack: "Cloud & DevOps",
      progressPercentage: "40%"
    }
  ],

  displayCodersrank: false
};

// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    {
  role: "Microservice Developer",
  company: "IT services",
  companylogo: null,
  date: "2023 - Present",
  desc:
    "Since 2023, I've been the Java developer on a banking platform people use every day. Building backend, fixing bugs, hooking systems together — pretty 'normal' work, except it has to be right because it's someone's actual money on the line.",

  descBullets: [
    "Build and maintain backend services with Java 21 & Spring Boot (MVC, Microservices, Hibernate/JPA)",
    "Design REST APIs — logic, validation, all the basics that need to be solid",
    "Connect the bank's systems with third-party APIs so transactions actually go through end to end",
    "Close out security findings (VAPT), wire up OAuth2/JWT, before anything ships",
    "Write JUnit/Mockito tests, then deal with whatever breaks after release anyway",
    "When production has an issue, I'm one of the people digging through Redis, Splunk, and Dynatrace to find out why",
  ]
},
    {
      role: "Junior Programmer",
      company: "Edess Education Development And Solutions Specialist Sdn Bhd",
      companylogo: require("./assets/images/edess.jpg"),
      date: "Oct 2018 – Aug 2019",
      desc: "My first job after my diploma — built the Al-Bayen LMS from scratch for a small startup.",
      descBullets: [
        "Talked to the client, turned what they wanted into technical specs",
        "Built the whole app from the ground up — features, logic, database, all of it",
        "Deployed it to production and kept it running afterward",
        "Worked in a fast-moving startup where you just had to keep up"
      ]
    }
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: false // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Selected Work",
  subtitle: "A selection of applications, backend services and systems built throughout my software engineering journey.",
  projects: [
    {
      projectName:"AI-Powered Knowledge Assistant (ongoing)",
      projectDesc:
      "A side project to get my hands dirty with .NET tooling — a RAG assistant built with C#, .NET Aspire, Semantic Kernel, and Blazor. It reads documents, generates embeddings, and answers questions through a proper RAG pipeline, backed by PostgreSQL + pgvector.",
      footerLink:[]
    },
    {
      image: require("./assets/images/renbo1.webp"),
      projectName: "Rental and Borrow Management System",
      projectDesc: "A rent-and-borrow platform, the idea came out of pandemic boredom — got stuff lying around unused, list it so someone else can rent or borrow it. My final year project, built with Java and Spring Boot. Has a homepage, listings, subscriptions, user accounts. Went back to it later to fix up the security and clean up the architecture.",
      footerLink: [
        {
          name: "View full description",
          url: "https://drive.google.com/file/d/1VVCnvIwpffMoU9yt9aFkZleWPxvP6gRB/view?usp=sharing"
        }
        //  you can add extra buttons here.
      ]
    },
    {
      image: require("./assets/images/albayen1.png"),
      projectName: "Albayen",
      projectDesc: "An e-learning system for a Sekolah Agama in Johor — teachers upload homework and quizzes, students submit their work, parents and the school can keep track too. Still live and still being improved.",
      footerLink: [
        {
          name: "View full description",
          url: "https://drive.google.com/file/d/1VVCnvIwpffMoU9yt9aFkZleWPxvP6gRB/view?usp=sharing"
        }
      ]
    },
    {
      image: require("./assets/images/ojt1.png"),
      projectName: "On-Job-Training Management System (OJT MS)",
      projectDesc: "My diploma final year project — a system for managing students' industrial training placements, connecting students, supervisors, and companies so everyone can register, track progress, and leave reviews in one place.",
      footerLink: [
        {
          name: "View full description",
          url: "https://drive.google.com/file/d/1VVCnvIwpffMoU9yt9aFkZleWPxvP6gRB/view?usp=sharing"
        }
      ]
    },
  ],
  display: true // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Achievements And Certifications 🏆 "),
  subtitle:
    "Achievements, Certifications, Award Letters and Some Cool Stuff that I have done !",

  achievementsCards: [
    {
      title: "Google Code-In Finalist",
      subtitle:
        "First Pakistani to be selected as Google Code-in Finalist from 4000 students from 77 different countries.",
      image: require("./assets/images/codeInLogo.webp"),
      footerLink: [
        {
          name: "Certification",
          url: "https://drive.google.com/file/d/0B7kazrtMwm5dYkVvNjdNWjNybWJrbndFSHpNY2NFV1p4YmU0/view?usp=sharing"
        },
        {
          name: "Award Letter",
          url: "https://drive.google.com/file/d/0B7kazrtMwm5dekxBTW5hQkg2WXUyR3QzQmR0VERiLXlGRVdF/view?usp=sharing"
        },
        {
          name: "Google Code-in Blog",
          url: "https://opensource.googleblog.com/2019/01/google-code-in-2018-winners.html"
        }
      ]
    },
    {
      title: "Google Assistant Action",
      subtitle:
        "Developed a Google Assistant Action JavaScript Guru that is available on 2 Billion devices world wide.",
      image: require("./assets/images/googleAssistantLogo.webp"),
      footerLink: [
        {
          name: "View Google Assistant Action",
          url: "https://assistant.google.com/services/a/uid/000000100ee688ee?hl=en"
        }
      ]
    },

    {
      title: "PWA Web App Developer",
      subtitle: "Completed Certifcation from SMIT for PWA Web App Development",
      image: require("./assets/images/pwaLogo.webp"),
      footerLink: [
        {name: "Certification", url: ""},
        {
          name: "Final Project",
          url: "https://pakistan-olx-1.firebaseapp.com/"
        }
      ]
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle:
    "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",
  displayMediumBlogs: "true", // Set true to display fetched medium blogs instead of hardcoded ones
  blogs: [
    {
      url: "https://blog.usejournal.com/create-a-google-assistant-action-and-win-a-google-t-shirt-and-cloud-credits-4a8d86d76eae",
      title: "Win a Google Assistant Tshirt and $200 in Google Cloud Credits",
      description:
        "Do you want to win $200 and Google Assistant Tshirt by creating a Google Assistant Action in less then 30 min?"
    },
    {
      url: "https://medium.com/@saadpasta/why-react-is-the-best-5a97563f423e",
      title: "Why REACT is The Best?",
      description:
        "React is a JavaScript library for building User Interface. It is maintained by Facebook and a community of individual developers and companies."
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"
  ),

  talks: [
    {
      title: "Build Actions For Google Assistant",
      subtitle: "Codelab at GDG DevFest Karachi 2019",
      slides_url: "https://bit.ly/saadpasta-slides",
      event_url: "https://www.facebook.com/events/2339906106275053/"
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    "https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"
  ],
  display: false // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: "Let's Talk",
  subtitle:
    "Always happy to talk tech, hear about an interesting project, or the next opportunity — just message me.",
  number: "",
  email_address: "syafiqahnabilah98@gmail.com"
};

// Twitter Section

const twitterDetails = {
  userName: "twitter", //Replace "twitter" with your twitter username without @
  display: false // Set true to display this section, defaults to false
};

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails
};
